import { render, staticRenderFns } from "./ReportClick.vue?vue&type=template&id=bf3720e8&scoped=true"
import script from "./ReportClick.vue?vue&type=script&lang=js"
export * from "./ReportClick.vue?vue&type=script&lang=js"
import style0 from "./ReportClick.vue?vue&type=style&index=0&id=bf3720e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3720e8",
  null
  
)

export default component.exports